/** Chapter grouping of the ingest review list. Wired into `api.admin.ingestReview` via ingestReviewApi.ts. */

type RequestFn = <T>(path: string, options?: RequestInit, token?: string | null) => Promise<T>;

export type ChapterGroupCounts = { course_id: string | null; order: number | null; title: string | null; total: number; needs_fixing: number };

export const ingestChapterApi = (request: RequestFn) => ({
  /** Per-chapter counts for the same filters as the list (note items only). */
  chapterCounts: (token: string, q: { course_id?: string; status?: string }) => {
    const p = new URLSearchParams();
    if (q.course_id) p.set("course_id", q.course_id);
    if (q.status) p.set("status", q.status);
    return request<{ chapters: ChapterGroupCounts[] }>(`/admin/ingest/review/chapters?${p}`, {}, token);
  },
  /** Approves every draft topic of one chapter; topics that need fixing or are blocked are skipped. */
  approveChapter: (token: string, body: { course_id: string; chapter_order: number; on_conflict?: string; confirm_replace?: boolean }) =>
    request<{ approved: number; skipped: number; warnings: string[] }>("/admin/ingest/chapters/approve", { method: "POST", body: JSON.stringify(body) }, token),
});
